import { render, staticRenderFns } from "./TifKilometrosTurno.vue?vue&type=template&id=2810994a"
import script from "./TifKilometrosTurno.vue?vue&type=script&lang=js"
export * from "./TifKilometrosTurno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports